import { Component, OnInit, Renderer2, HostListener, AfterViewInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AuthBaseComponent } from '../auth-base/auth-base.component';
import { AuthenticationResult } from '../models/authentication.model';
import { ModalService } from 'hsg';
import { AuthUserService } from '../auth-user.service';
import { AuthenticationStatus } from '../enums/enums';

@Component({
  selector: 'app-auth-issue-date',
  templateUrl: './auth-issue-date.component.html',
  styleUrls: ['./auth-issue-date.component.css']
})
export class AuthIssueDateComponent extends AuthBaseComponent implements OnInit, AfterViewInit {

  constructor(private renderer: Renderer2, protected modalService: ModalService, protected authService: AuthUserService) {
    super(modalService, authService);
  }
  private readonly minDate = new Date(1948, 4, 14)
  private readonly maxDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
  public isValidDate: boolean;
  public date = { day: '', month: '', year: '' };
  public data: any = {};
  private inputs: any;

  @HostListener('input', ['$event']) onKeyDown(e: any) {
    let date = new Date(parseInt(this.date.year), parseInt(this.date.month) - 1, parseInt(this.date.day));
    this.isValidDate = date.getDate() == parseInt(this.date.day) &&
      date.getMonth() + 1 == parseInt(this.date.month) &&
      date.getFullYear() == parseInt(this.date.year) &&
      date >= this.minDate && date < this.maxDate;
    if (e.srcElement.maxLength != null && e.srcElement.maxLength === e.srcElement.value.length) {
      e.preventDefault();
      let index = parseInt(e.srcElement.getAttribute('data-index'));
      if (index == this.inputs.length - 1) {
        document.querySelector('button').focus();
      }
      else {
        this.inputs[++index].focus();
      }
    }
  }

  elasticLogit() {
    this.authUserService.sendAuthData("ElasticLogger", { elasticCode: '2157' })
      .subscribe(res => console.log("sent elasticLog code:2157 - open window", res), error => console.log("sent elasticLog - open window error!", error));
  }
  ngOnInit() {
    this.elasticLogit();
    this.data = this.modalService.data;
    sessionStorage.setItem("currentWindow", "תאריך הנפקה ת.ז");
    sessionStorage.setItem("elasticCode", "2191");
    this.isShowContactLink = this.shouldContactLink('authIssueDate');
    const element = this.renderer.selectRootElement('#idDay');
    setTimeout(() => element.focus(), 0);
  }
  ngAfterViewInit() {
    this.inputs = this.inputsQuery.map(elm => elm.elementRef.nativeElement);
  }
  submit(form: FormGroup) {
    const element = this.inputsQuery.map(elm => elm.elementRef.nativeElement).find(elm => elm.classList.contains('ng-invalid'));
    if (element) {
      element.setAttribute('aria-invalid', true);
      setTimeout(() => element.focus(), 0);
    }
    if (form.valid && this.isValidDate) {
      this.pending = true;
      this.serverError = null;
      //console.log("sent parametes", { ClientInsertedIdIssueDate: date });
      this.authUserService.sendAuthData("ValidateIdIssueDate", { year: parseInt(this.date.year), month: parseInt(this.date.month), day: parseInt(this.date.day) })
        .subscribe((res: AuthenticationResult) => {
          if (res.Status == AuthenticationStatus.Failure && res.Details.UserInputError == "InvalidIssueDate") {
            this.elasticLogit();
            this.serverError = "אנא בדוק את הפרטים שהזנת ונסה שנית"
          }
          else {
            this.modalService.close(res.Details);
          }
        }, () => this.pending = false,
          () => this.pending = false
        )
    }
    this.buildFormAccessibility();
  }
  validateDate() {
    let date = new Date(parseInt(this.date.year), parseInt(this.date.month) - 1, parseInt(this.date.day));
    this.isValidDate = date.getDate() == parseInt(this.date.day) &&
      date.getMonth() + 1 == parseInt(this.date.month) &&
      date.getFullYear() == parseInt(this.date.year) &&
      date >= this.minDate && date < this.maxDate;
    //console.log(this.isValidDate);
  }
}
